const getActivityFeedService = require(`../services/activityfeed.service`);

const activityFeed = (function() {
  const $activityFeed = $(`.activity-feed`);
  const $activityFeedList = $activityFeed.find(`ul`);
  const $activityMarkup = $(`.activity-feed-item`);
  const activity = {};


  const buildActivity = function() {
    // We need this in an .each function as on the Locker dashboard we also have an Activity Feed, so need to populate 2
    $activityFeedList.each(function() {
      const $newItem = $(this).find($activityMarkup).clone().removeAttr(`hidden`);
      $newItem.find(`.bage`).addClass(activity.type).find(`svg use`).attr(`xlink:href`, `#icon-${activity.type}`);
      $newItem.find(`.time`).text(activity.timeSince);
      $newItem.find(`.activity-user`).attr(`href`, `/user/${activity.userID}`).find(`span`).text(activity.name);
      $newItem.find(`.action`).text(activity.text);
      $newItem.find(`.highlight`).attr(`href`, activity.slug).text(activity.title);

      $(this).append($newItem);
    });
  };


  const activityFeedResults = function(response) {
    if (response.statusCode === 200) {
      $.each(response.data, function(key, content) {
        activity.slug = content.link;
        activity.title = content.title;
        activity.type = content.activity_type;
        activity.timeSince = content.time_since;
        activity.userID = content.user_id;
        activity.name = content.full_name;
        activity.text = content.activity_text;

        buildActivity();
      });
    }
  };


  const getActivityFeedData = function() {
    getActivityFeedService(activityFeedResults);
  };


  const init = function() {
    if ($activityFeed.length) {
      getActivityFeedData();
    }
  };

  return {
    init,
  };
}());

activityFeed.init();


// WEBPACK FOOTER //
// ./library/js/modules/activity-feed.js